import React from 'react';
import { Play, Trophy } from 'lucide-react';

const FifaCupWinnerPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 py-3 sm:py-6">
        {/* Most Popular */}
        <div className="bg-orange-500 rounded-lg p-3 sm:p-4 mb-3 sm:mb-4">
          <div className="flex items-center gap-2 sm:gap-3">
            <Play className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
            <h2 className="text-white font-bold text-base sm:text-lg">Most Popular</h2>
          </div>
        </div>

        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="flex items-center justify-between px-3 sm:px-4 py-2 sm:py-3 border-b">
            <div className="flex items-center gap-2 sm:gap-3">
              <Trophy className="w-5 h-5 sm:w-6 sm:h-6 text-yellow-500" />
              <h1 className="text-lg sm:text-2xl font-bold text-gray-900">FIFA Cup Winner</h1>
            </div>
            <div className="hidden sm:flex items-center gap-6 sm:gap-10 text-sm font-bold text-gray-900">
              <span>1</span>
              <span>X</span>
              <span>2</span>
            </div>
          </div>

          {/* Empty table state */}
          <div className="p-6 text-center text-gray-500 text-sm">
            No Real-Time Records Found
          </div>
        </div>
      </div>
    </div>
  );
};

export default FifaCupWinnerPage;


